import { z } from 'zod';

export const documentSchema = z.object({
  id: z.string(),
  title: z.string(),
  content: z.string().nullable().optional(),
  agencyId: z.string(),
  clientId: z.string().nullable().optional(),
  folderId: z.string().nullable().optional(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
});

export type DocumentSchema = z.infer<typeof documentSchema>;
